import { apiClient } from "../../../lib"

export const queryAPI = {
    create: async ({ payload }: { payload: any }): Promise<any> => {
        const response = await apiClient.post(`/queries-and-rfis`, payload);
        return response.data;
    },
    fetch: async ({ params }: { params: any }): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/queries-and-rfis?${queryString}`);
        return response.data;
    },
    fetchStates: async ({ params }: { params: any }): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/queries-and-rfis/stats?${queryString}`);
        return response.data;
    },
    get: async ({ queryId }: { queryId: string | null }): Promise<any> => {
        const response = await apiClient.get(`/queries-and-rfis/${queryId}`);
        return response.data;
    },
    update: async ({ queryId, payload }: { queryId: string, payload: any }): Promise<any> => {
        const response = await apiClient.put(`/queries-and-rfis/${queryId}`, payload);
        return response.data;
    }
};